import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {RequestService} from "../../../../services/request/request.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {WarningModalContentComponent} from "../../../../lib/warning-modal/warning-modal.component";

@Component({
  selector: 'app-single-background-check-recipient',
  templateUrl: './single-background-check-recipient.component.pug',
  styleUrls: ['./single-background-check-recipient.component.scss'],
  standalone: false
})
export class SingleBackgroundCheckRecipientComponent implements OnInit {

  @Input() recipient: any;
  @Input() backgroundCheck : any;
  @Input() backgroundChecks : any;
  @Input() flowsSelected : any;
  @Input() disable_edit = false;
  @Input() componentOnModal = false;
  @Output() editEmitter = new EventEmitter();
  @Output() deleteEmitter = new EventEmitter();
  private bsModalRef: any;
  dataToEdit = {};
  id = -1;
  loading = false;
  ENT_8918_MULTIPLE_BC = false;
  TRUST_752_VERIFICATION = false;

  isTrustApiConfigured = true;

  constructor(public modalService: BsModalService,
    public requestService: RequestService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
    this.ENT_8918_MULTIPLE_BC = this.permissions.isFeatureActivated('ent_8918_multiple_bg_checks');
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
  }

  editRecipient(recipient) {
    this.id = recipient['id'];
    this.dataToEdit = {
      "draftUid": localStorage.getItem('draft_background_check_uid'),
      "recipient": recipient
    }
  }

  editRecipientDetails(recipientToEdit) {
    let checks: any;
    if(this.ENT_8918_MULTIPLE_BC)
      checks = this.backgroundChecks
    else
      checks = this.backgroundCheck

    this.loading = true;
    this.requestService.editBackgroundChecks(
      recipientToEdit['recipient'],
      localStorage.getItem('draft_background_check_uid'),
      checks
    ).subscribe((data: any) => {
      this.editEmitter.emit(data)
      this.loading = false
    },
      (err: any) => {
        console.log(err);
        this.loading = false
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  deleteRecipient(event) {
    let initialState = {
      "title": $localize`Remove recipient`,
      "message": $localize`Do you want to continue?`
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.loading = true;
        const check: any = this.ENT_8918_MULTIPLE_BC ? undefined : this.backgroundCheck;

        this.requestService.removeBackgroundCheck(
          localStorage.getItem('draft_background_check_uid'),
          event['id'],
          check
        ).subscribe((data: any) => {
          this.deleteEmitter.emit(data)
          this.loading = false;
        },
          (err: any) => {
            console.log(err);
            this.loading = false;
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })
      }
    })
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error-recipients';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return '';
  }

  closeEvent() {
    this.id = -1
  }

}
